// eslint-disable-next-line
// @ts-ignore
import TemperatureDetectionWebWorker from 'comlink-loader!./temperatureDetectionWebWorker';
import TemperatureDetectionFakeWorker from './temperatureDetectionFakeWorker';

export default class TemperatureDetectionWorkerFactory {
  public static createWebWorker() {
    return new TemperatureDetectionWebWorker();
  }

  public static createFakeWorker() {
    return new TemperatureDetectionFakeWorker();
  }
}
